import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const GoogleIcon: React.FC<IconProps> = ({
  size = 24,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M12.5 0C15.7 0 18.4 1.2 20.5 3.1L17.1 6.6C15.8 5.4 14.2 4.8 12.5 4.8C9.4 4.8 6.7 6.9 5.8 9.7C5.5 10.4 5.4 11.2 5.4 12C5.4 12.8 5.5 13.6 5.8 14.3L5.9 14.5C6.9 17.2 9.5 19.2 12.5 19.2C14.1 19.2 15.5 18.8 16.6 18.1L16.8 17.9C17.9 17.1 18.7 15.9 18.9 14.5H12.5V9.8H23.8C23.9 10.6 24 11.4 24 12.3C24 15.9 22.7 19 20.4 21.1L20 21.4C18.1 23.1 15.5 24 12.5 24C7.9 24 4 21.5 2 17.8L1.8 17.4L1.6 17.1C0.9 15.5 0.5 13.8 0.5 12C0.5 10.2 0.9 8.5 1.6 6.9L1.8 6.6C3.7 2.7 7.8 0 12.5 0Z" fill={color} />
  </Svg>
);

GoogleIcon.displayName = 'GoogleIcon';
